export default __webpack_public_path__ + "static/media/star.7c9fb3d6.svg";